import { Field, Input, Textarea } from "@/ui";
import type { ReactNode } from "react";

interface TextFieldProps {
  id: string;
  label: ReactNode;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  readOnly?: boolean;
  hint?: ReactNode;
  /** 标签右侧问号里的详细说明。 */
  help?: ReactNode;
  error?: string;
  mono?: boolean;
  type?: "text" | "number" | "password" | "datetime-local" | "time";
  placeholder?: string;
}

/** 带标签的单行输入，页面里的文本与数字字段都用它。 */
export function TextField({ id, label, value, onChange, required, readOnly, hint, help, error, mono, type = "text", placeholder }: TextFieldProps) {
  return (
    <Field label={label} htmlFor={id} required={required} hint={hint} help={help} error={error}>
      <Input id={id} readOnly={readOnly} type={type} mono={mono} value={value} invalid={!!error} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
    </Field>
  );
}

interface LinesFieldProps { id: string; label: ReactNode; value: string; onChange: (v: string) => void; hint?: ReactNode; error?: string; rows?: number }

/** 多行文本：每行一个值的列表（IP 白名单、允许的 sender），或提交时才解析的 JSON。 */
export function LinesField({ id, label, value, onChange, hint, error, rows = 4 }: LinesFieldProps) {
  return (
    <Field label={label} htmlFor={id} hint={hint} error={error}>
      <Textarea id={id} className="ax-mono" rows={rows} value={value} invalid={!!error} onChange={(e) => onChange(e.target.value)} />
    </Field>
  );
}
